export const AllSizes = {
    X_SMALL: 'x-small',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    X_LARGE: 'x-large',
    XX_LARGE: 'xx-large',
};

export const ProgressSizes = {
    REGULAR: 'regular',
    COMPACT: 'compact',
};

export const CHECKBOX_SIZES = [
    AllSizes.MEDIUM,
    AllSizes.LARGE,
];

export const RADIO_SIZES = [
    AllSizes.MEDIUM,
    AllSizes.LARGE,
];

export const SPINNER_SIZES = [
    AllSizes.SMALL,
    AllSizes.MEDIUM,
    AllSizes.LARGE,
];

export const BUTTON_SIZES = [
    AllSizes.X_SMALL,
    AllSizes.SMALL,
    AllSizes.MEDIUM,
    AllSizes.LARGE,
    AllSizes.X_LARGE,
];

export const SNACKBAR_SIZES = [
    AllSizes.MEDIUM,
    AllSizes.LARGE,
];

export const INPUT_SIZES = [
    AllSizes.MEDIUM,
    AllSizes.SMALL,
    'custom',
];

export const DOT_SIZES = [
    AllSizes.SMALL,
    AllSizes.MEDIUM,
    AllSizes.LARGE,
    AllSizes.X_LARGE,
    AllSizes.XX_LARGE,
];

export const PROGRESS_SIZES = [
    ProgressSizes.REGULAR,
    ProgressSizes.COMPACT,
];

export const APP_SIZES = [
    AllSizes.X_SMALL,
    AllSizes.SMALL,
    AllSizes.MEDIUM,
    AllSizes.LARGE,
    AllSizes.X_LARGE,
    AllSizes.XX_LARGE,
];

export const linkSizes = {
    LARGE: 'large',
    SMALL: 'small',
    REGULAR: 'regular',
};

export const LINK_SIZES = [
    linkSizes.LARGE,
    linkSizes.SMALL,
    linkSizes.REGULAR,
];
